import { localeFormatDefault } from '@/plugins/date-print';

export default class HallSettings {
  constructor(item) {
    this.id = item.id;
    this.start_accepting_at = item.start_accepting_at ? localeFormatDefault(item.start_accepting_at) : null;
    this.end_accepting_at = item.end_accepting_at  ? localeFormatDefault(item.end_accepting_at) : null;
    this.upload_grant = item.upload_grant;
    this.is_allow_any_decoration_type = item.is_allow_any_decoration_type;
    this.is_description_required = item.is_description_required;
    this.is_moderated = item.is_moderated;
    this.min_video = item.min_video;
    this.max_video = item.max_video;
    this.min_images = item.min_images;
    this.max_images = item.max_images;
    this.min_tags = item.min_tags;
    this.max_tags = item.max_tags;
    this.min_documents = item.min_documents;
    this.max_documents = item.max_documents;
    this.available_upload_event_ids = item.available_upload_event_ids;
  }
}
